import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/default-page-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`list of all pages`}</h1>
    <p><strong parentName="p">{`on the completed side:`}</strong></p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/"
        }}>{`home`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/all"
        }}>{`list of all pages`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/code"
        }}>{`code`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/languages"
        }}>{`languages`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/choose"
        }}>{`choose`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/thanks"
        }}>{`acknowledgements`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/fail"
        }}>{`fail`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/point-to"
        }}>{`point to`}</a></li>
    </ol>
    <p><strong parentName="p">{`in progress:`}</strong></p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/mahacks"
        }}>{`mahacks`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/communities"
        }}>{`communities`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/bacteria"
        }}>{`bacteria`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/leadership"
        }}>{`leadership`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/meta"
        }}>{`about this project`}</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      